(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8313],{

/***/ 30571:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return __webpack_require__(49829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ page_layout_PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/additional-note/AdditionalNote.module.scss
var AdditionalNote_module = __webpack_require__(57366);
var AdditionalNote_module_default = /*#__PURE__*/__webpack_require__.n(AdditionalNote_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/html-viewer/HtmlViewer.tsx


var HtmlViewer = /*#__PURE__*/ react.memo(function(param) {
    var tmp = param.as, Element = tmp === void 0 ? "div" : tmp, content = param.content, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
        className: className,
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
});
/* harmony default export */ var html_viewer_HtmlViewer = (HtmlViewer);

;// CONCATENATED MODULE: ./components/html-viewer/index.ts


;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/additional-note/AdditionalNote.tsx





var AdditionalNote = function(param) {
    var additionalNote = param.additionalNote, className = param.className;
    var ref = additionalNote || {}, title = ref.title, description = ref.description;
    if (!title && !description) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((AdditionalNote_module_default()).container, className),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h5",
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(html_viewer_HtmlViewer, {
                content: description
            })
        ]
    });
};
/* harmony default export */ var additional_note_AdditionalNote = (AdditionalNote);

// EXTERNAL MODULE: ./blocks/Layouts/page-layout/PageLayout.module.scss
var PageLayout_module = __webpack_require__(77669);
var PageLayout_module_default = /*#__PURE__*/__webpack_require__.n(PageLayout_module);
;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/PageLayout.tsx





var PageLayout = function(param) {
    var children = param.children, title = param.title, image = param.image, heading = param.heading, description = param.description, additionalNote = param.additionalNote;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (PageLayout_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (PageLayout_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PageLayout_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "grey-dark",
                                    weight: "medium",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                    as: "h1",
                                    className: (PageLayout_module_default()).title,
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    className: (PageLayout_module_default()).subtitle,
                                    children: description
                                })
                            ]
                        }),
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PageLayout_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image,
                                alt: "Header image for ".concat(title, " page"),
                                className: (PageLayout_module_default()).image,
                                layout: "fill",
                                priority: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (PageLayout_module_default()).content,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(additional_note_AdditionalNote, {
                additionalNote: additionalNote
            })
        ]
    });
};
/* harmony default export */ var page_layout_PageLayout = (PageLayout);

;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/index.ts



/***/ }),

/***/ 95182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowUpRight = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: "Arrow Up Right"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7 17L17 7M17 7H7M17 7V17",
                stroke: "#101828",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowUpRight);


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 49829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ press; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/index.ts + 4 modules
var page_layout = __webpack_require__(80264);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./components/ImageComponent/index.ts + 1 modules
var ImageComponent = __webpack_require__(87050);
// EXTERNAL MODULE: ./blocks/press/press-article-card/_PressArticleCard.module.scss
var _PressArticleCard_module = __webpack_require__(81551);
var _PressArticleCard_module_default = /*#__PURE__*/__webpack_require__.n(_PressArticleCard_module);
// EXTERNAL MODULE: ./services/DateService/DateService.ts
var DateService = __webpack_require__(57838);
// EXTERNAL MODULE: ./components/text/BaseText.tsx
var BaseText = __webpack_require__(2466);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./components/icons/ArrowUpRight.tsx
var ArrowUpRight = __webpack_require__(95182);
;// CONCATENATED MODULE: ./blocks/press/press-article-card/PressArticleCard.tsx










var PressArticleCard = function(param) {
    var image = param.image, title = param.title, description = param.description, date = param.date, className = param.className, id = param.id, digitalUrl = param.digitalUrl;
    // digitalUrl means external link, so we use it as href, otherwise we use the internal link
    var cardHref = digitalUrl || constants/* navigationPaths.PRESS_DETAIL.replace */.aY.PRESS_DETAIL.replace(":id", "".concat(id));
    var linkTarget = digitalUrl ? "_blank" : "_self";
    // security rel attribute for external links
    var linkRel = digitalUrl ? "noopener noreferrer" : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (0,clsx/* default */.Z)((_PressArticleCard_module_default()).card, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: cardHref,
            className: (_PressArticleCard_module_default()).card__link,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                target: linkTarget,
                "aria-label": title,
                href: cardHref,
                rel: linkRel,
                className: (_PressArticleCard_module_default()).card__link,
                title: title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: (_PressArticleCard_module_default()).card__image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageComponent/* Image */.E, {
                            src: image !== null && image !== void 0 ? image : "",
                            alt: title,
                            style: {
                                width: "100%",
                                height: "100%",
                                aspectRatio: "16/9",
                                objectFit: "contain",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                backgroundColor: "#ffffff"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (_PressArticleCard_module_default()).card__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseText/* BaseText */.k, {
                                    weight: "demiBold",
                                    className: (_PressArticleCard_module_default()).card__content__date,
                                    children: DateService/* default.getFormattedDateString */.Z.getFormattedDateString(date)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (_PressArticleCard_module_default()).card__content__title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                        as: "h1",
                                        weight: "demiBold",
                                        fontSize: "18px",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpRight/* default */.Z, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                className: (_PressArticleCard_module_default()).card__content__description,
                                children: description
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var press_article_card_PressArticleCard = (PressArticleCard);

;// CONCATENATED MODULE: ./blocks/press/press-article-card/index.ts


// EXTERNAL MODULE: ./blocks/press/_Press.module.scss
var _Press_module = __webpack_require__(14431);
var _Press_module_default = /*#__PURE__*/__webpack_require__.n(_Press_module);
;// CONCATENATED MODULE: ./blocks/press/Press.tsx



var Press = function(param) {
    var pressList = param.pressList;
    var _image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (_Press_module_default()).pressListSection,
        children: pressList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (_Press_module_default()).pressListSection__item,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(press_article_card_PressArticleCard, {
                    id: item.id,
                    image: (_image = item.image) !== null && _image !== void 0 ? _image : "#",
                    title: item.title,
                    description: item.description,
                    date: item.date,
                    digitalUrl: item.digitalUrl
                })
            }, item.id);
        })
    });
};
/* harmony default export */ var press_Press = (Press);

;// CONCATENATED MODULE: ./blocks/press/index.ts


// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
;// CONCATENATED MODULE: ./assets/press/header-image.webp
/* harmony default export */ var header_image = ({"src":"/_next/static/media/header-image.dd828642.webp","height":1000,"width":1780,"blurDataURL":"data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAADQAQCdASoIAAQAAkA4JYgCdAEUo8wC8ADiepMaHSJFGjh5HJUQcqcOmOqUHZOssmnOOly7vY31XsAA","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./pages/press/index.tsx







var PressPage = function(param) {
    var globalLayoutProps = param.globalLayoutProps, pressList = param.pressList, pageContent = param.pageContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContent), {
            image: header_image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(press_Press, {
                pressList: pressList
            })
        }))
    }));
};
var __N_SSG = true;
/* harmony default export */ var press = (PressPage);


/***/ }),

/***/ 77669:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__6G5D5","header":"PageLayout_header__ASkvF","wrapper":"PageLayout_wrapper__XsyyL","title":"PageLayout_title__kxaL3","subtitle":"PageLayout_subtitle__qfdRt","content":"PageLayout_content__PWx2_","imageWrapper":"PageLayout_imageWrapper__mMJRv","image":"PageLayout_image__wdXuU"};

/***/ }),

/***/ 57366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalNote_container__W2gN_"};

/***/ }),

/***/ 14431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pressListSection":"_Press_pressListSection__Hb2ib","pressListSection__item":"_Press_pressListSection__item__sy9By"};

/***/ }),

/***/ 81551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"_PressArticleCard_card__Nu0gO","card__image":"_PressArticleCard_card__image__2_5Xr","card__link":"_PressArticleCard_card__link__DZggh","card__content":"_PressArticleCard_card__content__jp8z5","card__content__date":"_PressArticleCard_card__content__date__pL1wF","card__content__title":"_PressArticleCard_card__content__title__43Uki","card__content__description":"_PressArticleCard_card__content__description__dGDRA"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5901,1608,4520,2394,9774,2888,179], function() { return __webpack_exec__(30571); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);